module.exports = __webpack_public_path__ + "9944df4c3e6087b082c744982dc13155.svg";